import React from 'react';
import { PayPalRadio, ApplePayRadio } from '@fff-web/fff-ui-shared/Icon';
import { IPaymentTabs } from '../../../interfaces';
import BillingOption from './BillingOption';

import { APPLE_PAY, CREDIT_CARD, PAYPAL, VENMO } from '../../utils/constants';
import venmoBlueLogo from '../../assets/venmo-blue.png';
import styles from './PaymentTabs.module.css';

const PaymentTabs: React.FunctionComponent<IPaymentTabs> = ({
  billingMethod,
  setBillingMethod,
  showVenmoOption,
  showApplePayOption,
}) => (
  <fieldset id="billingOptions" className={styles.ptContainer}>
    <BillingOption
      selfBillingMethod={CREDIT_CARD}
      billingMethod={billingMethod}
      setBillingMethod={setBillingMethod}
    >
      <div>Credit or Debit Card</div>
    </BillingOption>
    <BillingOption
      selfBillingMethod={PAYPAL}
      billingMethod={billingMethod}
      setBillingMethod={setBillingMethod}
    >
      <div className={styles.payPalLogo}>
        <PayPalRadio />
      </div>
    </BillingOption>
    {showApplePayOption && (
      <BillingOption
        selfBillingMethod={APPLE_PAY}
        billingMethod={billingMethod}
        setBillingMethod={setBillingMethod}
        disabled={!showApplePayOption}
      >
        <div className={styles.applePayLogo}>
          <ApplePayRadio />
        </div>
      </BillingOption>
    )}
    {showVenmoOption && (
      <BillingOption
        selfBillingMethod={VENMO}
        billingMethod={billingMethod}
        setBillingMethod={setBillingMethod}
      >
        <div className={styles.venmoLogo}>
          <img src={venmoBlueLogo} alt="Check Out with Venmo" />
        </div>
      </BillingOption>
    )}
  </fieldset>
);

export default PaymentTabs;
